var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({on:{"click":_vm.onClick}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_vm._v(_vm._s(_vm.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }